import AntIcon from "./AntIcon";

const PopconfirmDeleteIcon = () => <AntIcon type="question" color="red" />;

export default PopconfirmDeleteIcon;
